import React from 'react';
import './styles.scss';

const Toast = ({show, message}) => (
    <div className='toast show' >{message}</div>
)

export default Toast;